<div class="row">
  <div class="col-12 mb-4">
    <div class="my-9">
      <h2 class="h2">{{ 'habaNavLogin.register' | cxTranslate }}</h2>
    </div>
    <div class="login-register-title">
      {{ 'habaGuestLogin.title' | cxTranslate }}
    </div>
    <button
      class="btn btn-full btn-secondary"
      [routerLink]="{ cxRoute: 'checkoutBillingAddress' } | cxUrl"
    >
      {{ 'habaGuestLogin.next' | cxTranslate }}
    </button>
  </div>
  <div class="col-12">
    <app-dynamic-grid
      [internalId]="DynamicContentfulGrid.login_checkout_register_grid"
    ></app-dynamic-grid>
  </div>
</div>
